import _ from "lodash";
import { ReactElement } from "react";

import { palette } from "~frontend/theme";

import { Chart } from "./Chart";
import { ChartContainer } from "./ChartContainer";
import { Month } from "./monthlyBuckets";
import { maybeNumberToPercentage } from "./numbers";

type Data = {
  month: Month;
  donorConversionRate?: number;
}[];

export function DonorConversionRateChart({
  data,
}: {
  data: Data | null;
}): ReactElement {
  return (
    <ChartContainer
      title="Donor Conversion Rate"
      loading={!data}
      downloadableRows={data?.map(r => ({
        month: r.month.toString(),
        donorConversionRate: (r.donorConversionRate ?? 0).toFixed(4),
      }))}
      downloadFileName="donorConversionRate.csv"
      empty={data?.length === 0}
    >
      <Chart
        data={data ?? []}
        series={[
          {
            type: "line",
            yAxisId: "conversionRate",
            label: "Donor Rate",
            color: palette.blue,
            getValue: d => d.donorConversionRate ?? null,
          },
        ]}
        getXAxisValue={data => data.month.toString()}
        xAxisLabel="Campaign Start Month"
        xAxisTicks={4}
        yAxes={{
          conversionRate: {
            formatValue: value => maybeNumberToPercentage(value)!,
            formatTick: value => maybeNumberToPercentage(value)!,
            label: "Donor Rate",
            width: 60,
          },
        }}
        height={280}
      />
    </ChartContainer>
  );
}
